import { useState, useEffect } from 'react'
import React from 'react';
import '../styles/App.css';
import GuessCharacter from './GuessCharacter.js';
import InputCharacter from './InputCharacter.js';
import GrilleCharacter from './GrilleCharacter.js';
import Countdown from './Countdown.js';
import Prev from './Prev.js';
import Rules from './Rules.js';
import Nav from './Nav.js';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;


function ModeCharacter() {

  const gameMode = 'character'

  // Crée un nouvel objet Date avec la date et l'heure actuelles
  var dateDuJour = new Date();
  // Récupère les composantes de la date
  var annee = dateDuJour.getFullYear();
  var mois = (dateDuJour.getMonth() + 1).toString().padStart(2, '0'); // Les mois commencent à 0 en JS, donc on ajoute 1
  var jour = dateDuJour.getDate().toString().padStart(2, '0');
  // Formate la date en "yyyy-mm-dd"
  var dateFormatee = `${annee}-${mois}-${jour}`;


  const [characterFind, setcharacterFind] = useState(0);
  const savedrowsLocal = localStorage.getItem('rows-characters')
  let savedrows = null;
  if (savedrowsLocal ) {  savedrows =  JSON.parse(savedrowsLocal).filter(row => row.dateFormatee === dateFormatee && row.gameMode === gameMode); }
  // const savednbTestMax = localStorage.getItem('nbTestMax')
  const [characterNow, setCharacterNow] = useState([]);
  const [nbTest, nbTestUpdate] = useState(savedrows ? savedrows.length : 0)
  const [nbTestMax, nbTestMaxUpdate] = useState(nbTest === 10 ? 1 : 0)

  
  // Initialiser gameNow avec l'item du jour
  useEffect(() => {
    const fetchcharacterNow = async () => {
      try {
        const response = await fetch(URL_BACKEND+'/api/characters-now');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const characterNow = await response.json();
        console.log('Data characterNow fetched successfully:', characterNow);
        setCharacterNow(characterNow);
        console.log('characterNow', characterNow);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchcharacterNow();
  }, []);

  
	const [rows, rowsUpdate] = useState(savedrows ? savedrows : [])
  // Stockage des inputs dans le localstorage + mise à jour
	useEffect(( ) => {
    if (characterNow.length === 0) {
      // Wait until gameNow is fetched
      return;
    }
		localStorage.setItem('rows-characters', JSON.stringify(rows))

    // Mise à jour du nombre de coup
    nbTestUpdate(rows.length)
    console.log('lenght', rows.length)
    // Mise à jour si le nombre de coup est de 10
    rows.length === 10 ? nbTestMaxUpdate(1) : nbTestMaxUpdate(0)
    
    // Mise à jour si le nombre de coup est de 10
    if (rows.length > 0 && rows[0].id_personnage === characterNow.id_personnage) { setcharacterFind(1) } else  { setcharacterFind(0) }


	}, [rows, characterNow])

    return (
      <div >
        <Nav />
        
        <InputCharacter     
            gameMode={gameMode} 
            rows={rows}
            rowsUpdate={rowsUpdate}
            characterNow={characterNow}
            setCharacterNow={setCharacterNow}
            characterFind={characterFind}
            nbTestMax={nbTestMax}
            nbTest={nbTest}
            dateFormatee={dateFormatee}
        />
        {nbTestMax === 1 || characterFind === 1 ?
          <Countdown />
          : <GuessCharacter       
              gameMode={gameMode} 
              characterNow={characterNow}
              nbTest={nbTest}
          />
        }
        <GrilleCharacter
            gameMode={gameMode} 
            rows={rows}
            rowsUpdate={rowsUpdate}
            characterNow={characterNow}
        />
        <Prev 
          gameMode={gameMode} 
        />
        <Rules 
          gameMode={gameMode} 
        />   
    </div>
	)
}

export default ModeCharacter
